// photo received status of an inv batch item, dependant to backend changes
export const PHOTO_RECEIVED_STATUSES = {
  COMPLETE : 'complete',
  PENDING  : 'pending'
}

// photography status of an inv batch item, dependant to backend changes
export const PHOTOGRAPHY_STATUSES = {
  COMPLETE : 'complete',
  PENDING  : 'pending'
}

// photo edit status of an inv batch item, dependant to backend changes
export const PHOTO_EDIT_STATUSES = {
  COMPLETE : 'complete',
  PENDING  : 'pending'
}

// put away status of an inv batch item, dependant to backend changes
export const PUT_AWAY_STATUSES = {
  COMPLETE : 'complete',
  PENDING  : 'pending'
}

// put away status of an inv batch item (supposedly routes to the seller product status), dependant to backend changes
export const PHOTO_UPLOAD_STATUSES = {
  COMPLETE : 'complete',
  PENDING  : 'pending'
}

// static code, no relation with backend
export const TABLE_STATUS = {
  PENDING_RECEIVED     : 'pending_received',
  RECEIVED             : 'received',
  PENDING_PHOTOGRAPHY  : 'pending_photography',
  COMPLETE_PHOTOGRAPHY : 'complete_photography',
  REJECTED             : 'rejected',
  PENDING_PUT_AWAY     : 'pending_put_away',
  COMPLETE_PUT_AWAY    : 'complete_put_away',
  PENDING_PHOTO_EDIT   : 'pending_photo_edit',
  COMPLETE_PHOTO_EDIT  : 'complete_photo_edit'
}